import NAME from "./constants";

export const getOrgStructure = store => store[NAME].orgChart;
export const getStatistics = store => store[NAME].statistics;
export const getDepartmentOccupationData = store => store[NAME].occupationData;
export const getLoading = store => store[NAME].gettingOrgChart;